






















































































































































































import { Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'

@Component({
  props: {},
  components: {}
})
export default class SearchFilter extends Vue {
  // data
  private allStatuses = ['Available', 'Selected', 'Deprecated']

  // computed
  get allProviders() {
    return vxm.dappservices.getAllProviders
  }

  get allServices() {
    return vxm.dappservices.getAllServices
  }

  get minStakeRange() {
    return vxm.packages.getMinStakeRange
  }

  get quotaRange() {
    return vxm.packages.getQuotaRange
  }

  get pkgPeriodRange() {
    return vxm.packages.getPkgPeriodRange
  }

  get showFilter() {
    return vxm.packages.showFilter
  }

  get selectedProvider() {
    return vxm.packages.selectedProvider
  }
  set selectedProvider(value) {
    vxm.packages.setSelectedProvider(value)
  }

  get selectedService() {
    return vxm.packages.selectedService
  }
  set selectedService(value) {
    vxm.packages.setSelectedService(value)
  }

  get selectedMinStake() {
    return vxm.packages.selectedMinStake
  }
  set selectedMinStake(value) {
    vxm.packages.setSelectedMinStake(value)
  }

  get selectedQuota() {
    return vxm.packages.selectedQuota
  }
  set selectedQuota(value) {
    vxm.packages.setSelectedQuota(value)
  }

  get selectedPkgPeriod() {
    return vxm.packages.selectedPkgPeriod
  }
  set selectedPkgPeriod(value) {
    vxm.packages.setSelectedPkgPeriod(value)
  }

  get selectedStatus() {
    return vxm.packages.selectedStatus
  }

  set selectedStatus(value) {
    vxm.packages.setSelectedStatus(value)
  }

  get sortBy() {
    return vxm.packages.sortBy
  }

  set sortBy(value) {
    vxm.packages.setSortOrder({ sort: value, order: this.orderBy })
  }

  get orderBy() {
    return vxm.packages.orderBy
  }

  set orderBy(value) {
    vxm.packages.setSortOrder({ sort: this.sortBy, order: value })
  }

  // methods
  getSortString(sort: string) {
    switch (sort) {
      case 'random': {
        return this.$t('view.packages.random')
      }
      case 'provider': {
        return this.$tc('view.packages.providers', 1)
      }
      case 'service': {
        return this.$tc('view.packages.services', 1)
      }
      case 'package_id': {
        return this.$tc('view.packages.packages', 1)
      }
      case 'quota': {
        return this.$t('view.packages.quota')
      }
      case 'min_stake_quantity': {
        return this.$t('view.packages.minStake')
      }
      default: {
        return sort
      }
    }
  }

  reset() {
    this.selectedService = this.selectedProvider = []
  }

  // Lifecycle hooks
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
